import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-arrow-square-left',
  imports: [],
  templateUrl: './icon-arrow-square-left.component.html',
  styleUrl: './icon-arrow-square-left.component.scss',
})
export class IconArrowSquareLeftComponent {
  @Input() color: string = '#171717';
  @Input() size: string = '24px';
}
